export default __webpack_public_path__ + "static/media/Snd_TryT.462a4761.mp3";